// eslint-disable-next-line import/no-amd
define(['backbone', 'async'], (Backbone, async) => {
    const MabinsoCollection = Backbone.Collection.extend({
        eachAsync: function myAsync(fn, done, aLimit) {
            const myLimit = aLimit || 10;
            async.eachLimit(this.models, myLimit, fn, done);
        },
        eachAsync2: function test(fn, maxTimePerChunk, cxt) {
            const context = cxt || window;
            maxTimePerChunk = maxTimePerChunk || 200;
            const _array = this.models || [];
            let index = 0;

            function now() {
                return new Date().getTime();
            }

            function doChunk() {
                const startTime = now();
                while (index < _array.length && (now() - startTime) <= maxTimePerChunk) {
                    // callback called with args (value, index, array)
                    fn.call(context, _array[index], index, _array);
                    index += 1;
                }
                if (index < _array.length) {
                    // set Timeout for async iteration
                    setTimeout(doChunk, 1);
                }
            }
            doChunk();
        }
    });
    return MabinsoCollection;
});



// WEBPACK FOOTER //
// ./src/components/app/models/MabinsoCollection.js